{
  "title": "Hỗ trợ",
  "subtitle": "Tạo và theo dõi yêu cầu hỗ trợ của bạn.",
  "newTicket": "Tạo ticket",
  "newReply": "Phản hồi mới",
  "quick": {
    "heading": "Thao tác nhanh",
    "trackOrder": {
      "label": "Theo dõi đơn hàng",
      "caption": "Kiểm tra trạng thái hoặc vị trí của đơn hàng.",
      "subject": "Theo dõi đơn hàng của tôi",
      "description": "Tôi muốn kiểm tra trạng thái và vị trí hiện tại của đơn hàng. Mã đơn hàng: "
    },
    "startReturn": {
      "label": "Yêu cầu trả hàng",
      "caption": "Gửi yêu cầu trả hàng hoặc hoàn tiền cho đơn hàng.",
      "subject": "Yêu cầu trả hàng",
      "description": "Tôi muốn yêu cầu trả hàng hoặc hoàn tiền cho đơn hàng. Mã đơn hàng: \nLý do: "
    },
    "orderIssues": {
      "label": "Sự cố đơn hàng",
      "caption": "Báo cáo vấn đề về sản phẩm hoặc giao hàng.",
      "subject": "Sự cố với đơn hàng của tôi",
      "description": "Tôi đang gặp sự cố với một sản phẩm trong đơn hàng. Mã đơn hàng: \nVấn đề gặp phải: "
    },
    "paymentHelp": {
      "label": "Hỗ trợ thanh toán",
      "caption": "Nhận hỗ trợ về hoá đơn hoặc thanh toán.",
      "subject": "Hỗ trợ thanh toán / hoá đơn",
      "description": "Tôi cần hỗ trợ về vấn đề thanh toán hoặc hoá đơn. Vui lòng mô tả câu hỏi của bạn: "
    }
  },
  "tabs": {
    "all": "Tất cả",
    "Open": "Mở",
    "InProgress": "Đang xử lý",
    "Resolved": "Đã xử lý",
    "Closed": "Đã đóng"
  },
  "status": {
    "Open": "Mở",
    "InProgress": "Đang xử lý",
    "Resolved": "Đã xử lý",
    "Closed": "Đã đóng",
    "Reopened": "Mở lại"
  },
  "category": {
    "Order": "Đơn hàng",
    "Billing": "Thanh toán",
    "Product": "Sản phẩm",
    "Account": "Tài khoản"
  },
  "priority": {
    "Critical": "Khẩn cấp",
    "High": "Cao",
    "Medium": "Trung bình",
    "Low": "Thấp"
  },
  "filters": {
    "issueType": "Loại vấn đề",
    "allTypes": "Tất cả loại",
    "refresh": "Làm mới"
  },
  "card": {
    "order": "Đơn:",
    "replies": "Phản hồi",
    "updated": "Cập nhật {{time}}"
  },
  "table": {
    "subject": "Tiêu đề",
    "category": "Danh mục",
    "priority": "Ưu tiên",
    "status": "Trạng thái",
    "updated": "Cập nhật",
    "ticketNumber": "Mã ticket"
  },
  "list": {
    "loading": "Đang tải…",
    "error": "Không tải được danh sách ticket.",
    "empty": "Chưa có ticket nào.",
    "searchPlaceholder": "Tìm theo mã ticket hoặc tiêu đề..."
  },
  "modal": {
    "title": "Tạo ticket hỗ trợ",
    "subjectLabel": "Tiêu đề",
    "subjectPlaceholder": "Tóm tắt vấn đề của bạn",
    "categoryLabel": "Danh mục",
    "priorityLabel": "Ưu tiên",
    "descriptionLabel": "Mô tả",
    "descriptionPlaceholder": "Mô tả chi tiết vấn đề bạn gặp phải",
    "cancel": "Huỷ",
    "submit": "Tạo ticket",
    "submitting": "Đang tạo…",
    "error": "Tạo ticket thất bại.",
    "orderLabel": "Đơn hàng liên quan (tùy chọn)",
    "orderNone": "— Không có đơn —",
    "orderSearchPlaceholder": "Tìm đơn hàng…",
    "orderNoResults": "Không tìm thấy đơn hàng",
    "orderSelectedCount": "Đã liên kết {{count}} đơn",
    "orderRemove": "Bỏ {{order}}"
  },
  "detail": {
    "back": "Danh sách ticket",
    "loading": "Đang tải…",
    "notFound": "Không tìm thấy ticket.",
    "createdAt": "Tạo {{date}}",
    "you": "Bạn",
    "agent": "Hỗ trợ",
    "closed": "Ticket đã đóng.",
    "replyPlaceholder": "Nhập phản hồi…",
    "send": "Gửi",
    "sending": "Đang gửi…",
    "resolutionTitle": "Hướng xử lý",
    "conversation": "Hội thoại",
    "detailsHeading": "Chi tiết",
    "fieldStatus": "Trạng thái",
    "fieldPriority": "Ưu tiên",
    "fieldCategory": "Danh mục",
    "fieldOrder": "Đơn hàng",
    "fieldAssignee": "Phụ trách",
    "fieldCreated": "Tạo lúc",
    "fieldUpdated": "Cập nhật",
    "unassigned": "Chưa gán",
    "ticketInfo": "Thông tin ticket",
    "fieldIssueType": "Loại vấn đề",
    "fieldLastUpdated": "Cập nhật cuối",
    "relatedOrders": "Đơn hàng liên quan",
    "noRelatedOrders": "Không có đơn liên quan",
    "activityTimeline": "Dòng thời gian",
    "ticketCreated": "Đã tạo ticket",
    "supportReplied": "Hỗ trợ đã trả lời",
    "noMessages": "Chưa có tin nhắn nào.",
    "resolvedPrompt": "Support đã đánh dấu ticket là đã xử lý. Bạn có hài lòng không?",
    "reopenBtn": "Chưa hài lòng — mở lại",
    "reopenCommentPlaceholder": "Cho chúng tôi biết vấn đề còn lại (không bắt buộc)",
    "reopenSubmit": "Mở lại ticket",
    "reopenCancel": "Hủy",
    "confirmCloseBtn": "Xác nhận & đóng",
    "sent": "Đã gửi",
    "read": "Đã đọc",
    "viewAll": "Xem tất cả ({{count}})",
    "showLess": "Thu gọn",
    "closeTicket": "Đóng ticket",
    "download": "Tải xuống",
    "moreActions": "Thêm thao tác",
    "attachments": "Tệp đính kèm",
    "composePlaceholder": "Nhập tin nhắn… (Dán ảnh bằng Ctrl+V)",
    "youReplied": "Bạn đã trả lời",
    "ticketReopened": "Ticket được mở lại",
    "preferredResolution": "Hướng xử lý mong muốn: {{value}}"
  },
  "compose": {
    "keyboardHint": "Enter để gửi · Option+Enter để xuống dòng",
    "attach": "Đính kèm tệp",
    "uploading": "Đang tải lên…",
    "removeAttachment": "Xoá {{filename}}",
    "linkOrder": "Gắn đơn hàng",
    "searchOrder": "Tìm đơn hàng…",
    "noOrders": "Không tìm thấy đơn hàng",
    "uploadFailTitle": "Không thể tải tệp lên",
    "fileTooLarge": "Tệp vượt quá giới hạn 10MB",
    "fileTypeForbidden": "Định dạng tệp không được phép",
    "download": "Tải xuống",
    "imageAlt": "Ảnh đính kèm",
    "attachDisabledHint": "Chỉ đính kèm được khi dispatch đang hoạt động"
  },
  "stats": {
    "all": "Tất cả ticket",
    "open": "Đang mở",
    "inProgress": "Đang xử lý",
    "resolved": "Đã xử lý"
  },
  "resolution": {
    "Reprint": "In lại",
    "FullRefund": "Hoàn tiền toàn bộ",
    "PartialRefund": "Hoàn tiền một phần",
    "StoreCredit": "Store credit",
    "Replacement": "Đổi hàng",
    "ShippingCredit": "Hoàn phí ship",
    "NoActionRequired": "Không cần xử lý",
    "Escalated": "Đã chuyển cấp cao"
  },
  "rating": {
    "prompt": "Bạn thấy hỗ trợ thế nào? Đánh giá ticket này:",
    "starAria": "{{count}} sao",
    "commentPlaceholder": "Nhận xét (không bắt buộc)...",
    "submit": "Gửi đánh giá",
    "submitting": "Đang gửi...",
    "thanks": "Cảm ơn phản hồi của bạn!",
    "invite": "Ticket đã được xử lý — hãy cho chúng tôi biết đánh giá của bạn!",
    "inviteCta": "Đánh giá dịch vụ",
    "modalTitle": "Đánh giá dịch vụ hỗ trợ",
    "overall": "Mức độ hài lòng chung",
    "surveyResponsiveness": "Tốc độ phản hồi",
    "surveyHelpfulness": "Vấn đề của bạn đã được giải quyết chưa?",
    "surveyProfessionalism": "Sự chuyên nghiệp của nhân viên",
    "cancel": "Hủy"
  },
  "realtime": {
    "tabFlash": "Cập nhật ticket",
    "updateTitle": "Cập nhật ticket hỗ trợ",
    "updateBody": "Ticket của bạn có phản hồi mới."
  },
  "dispatch": {
    "title": "Đẩy cho vendor / bộ phận",
    "target": {
      "vendor": "Vendor",
      "department": "Bộ phận nội bộ"
    },
    "department": {
      "Finance": "Tài chính",
      "IT": "Kỹ thuật",
      "Logistics": "Vận hành/Giao vận",
      "Product": "Sản phẩm/Thiết kế"
    },
    "status": {
      "Dispatched": "Đã đẩy",
      "InProgress": "Đang xử lý",
      "Returned": "Đã trả về",
      "Cancelled": "Đã thu hồi"
    },
    "pickVendor": "Chọn vendor",
    "scopeNotePlaceholder": "Mô tả việc cho bên xử lý (không kèm PII merchant khi đẩy vendor)",
    "replyPlaceholder": "Trả lời trong luồng dispatch…",
    "submit": "Đẩy việc",
    "cancel": "Huỷ",
    "send": "Gửi",
    "return": "Trả về support",
    "recall": "Thu hồi",
    "empty": "Chưa có dispatch",
    "navTitle": "Hàng đợi dispatch",
    "toast": {
      "created": "Đã tạo dispatch",
      "error": "Thao tác thất bại"
    }
  },
  "linkOrder": {
    "title": "Liên kết đơn hàng",
    "searchPlaceholder": "Tìm đơn hàng theo mã…",
    "link": "Liên kết",
    "unlink": "Bỏ liên kết",
    "empty": "Không tìm thấy đơn hàng",
    "linked": "Đơn hàng đã liên kết"
  }
}
